<template>
  <CCard class="card--custom">
    <CCardBody>
      <form action="" class="d-flex flex-wrap">
        <div class="form-group col-12 p-0 d-flex flex-wrap">
          <div class="profile-image__account col-6">
              <div class="image-container relative m-auto" style="position: relative" v-if="hasProfilePic">
                  <div class="remove-pic bg-danger text-light" v-on:click="hasProfilePic = false"><i class="fas fa-times"></i></div>
                  <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT4lQHH4lXf8gt-fEpRHuQPB4N8l5VgYHYezg&usqp=CAU" alt="">
              </div>
            
            <div class="upload-image m-auto d-flex flex-column justify-content-center" v-if="hasProfilePic == false">
                <p>Subir foto</p>
            </div>
          </div>
          <div class="form-group col-6 p-0 mt-3 d-flex flex-wrap tablet-sm-12">
            <div class="form-group col-12 tablet-sm-6">
              <label for="">Correo electrónico</label>
              <input type="text" class="form-control" />
            </div>
            <div class="form-group col-12 tablet-sm-6">
              <label for="">Teléfono</label>
              <input type="text" class="form-control" />
            </div>
          </div>
        </div>

        <div class="col-12 mt-4">
          <small class="text-dark">Cambiar contraseña</small>
          <hr class="mt-0" />
        </div>

        <div class="form-group col-6">
          <label for="">Contraseña actual</label>
          <input type="password" class="form-control" />
        </div>
        <div class="form-group col-6"></div>
        <div class="form-group col-6">
          <label for="">Nueva contraseña</label>
          <input type="password" class="form-control" />
        </div>
        <div class="form-group col-6">
          <label for="">Repite contraseña</label>
          <input type="password" class="form-control" />
        </div>

        <div class="col-12 mt-4 d-flex justify-content-end">
          <div class="form-group d-flex justify-content-end col-3 tablet-sm-12 p-0">
            <button class="btn btn-primary--custom flex-grow-1">
              Actualizar
            </button>
          </div>
        </div>
      </form>
    </CCardBody>
  </CCard>
</template>

<script>
export default {
    data: function() {
        return {
            hasProfilePic: true
        }
    }
}
</script>